import axios from 'axios';
import { getServiceConfig } from '../config.js';
let currentAccessToken = null;
let accessTokenRequestedAt = null;
let currentAccessTokenExpiry = null;
let inProcess = false;
export const checkToken = async () => {
    if (inProcess) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(checkToken());
            }, 50);
        });
    }
    if (currentAccessToken && accessTokenRequestedAt && currentAccessTokenExpiry) {
        const now = new Date().getTime();
        if (now - accessTokenRequestedAt <= currentAccessTokenExpiry) {
            return currentAccessToken;
        }
    }
    try {
        const { tokenPath, apiKey, env } = getServiceConfig();
        inProcess = true;
        const response = await axios(`https://api${env === 'prod' ? '' : `-${env}`}.rfksrv.com${tokenPath}`, {
            method: 'POST',
            data: { scope: ['discover', 'event'] },
            headers: getTokenHeaders(apiKey),
        });
        inProcess = false;
        const { accessToken, accessTokenExpiry } = response.data;
        accessTokenRequestedAt = new Date().getTime();
        currentAccessToken = accessToken;
        currentAccessTokenExpiry = accessTokenExpiry;
        return currentAccessToken;
    }
    catch (e) {
        return null;
    }
};
export const resetToken = () => {
    currentAccessToken = null;
    accessTokenRequestedAt = null;
    currentAccessTokenExpiry = null;
};
export const getAPIHeaders = async () => {
    const { useAccessToken, apiKey } = getServiceConfig();
    const headers = {
        'Content-Type': 'application/json',
    };
    const accessToken = useAccessToken ? await checkToken() : null;
    if (accessToken) {
        return {
            ...headers,
            Authorization: `Bearer ${accessToken}`,
        };
    }
    else if (apiKey) {
        headers.Authorization = apiKey;
    }
    return headers;
};
export const getTokenHeaders = (apiKey) => {
    return {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
    };
};
